'use client';

import type React from 'react';
import { useLayoutEffect, useState } from 'react';

import { TailwindSizes, useIsMobile } from '@cineamo/ui/src/helpers/screen-type';

export type MobileOrDesktopRendererProps = {
    mobileContent?: React.JSX.Element;
    desktopContent?: React.JSX.Element;
    renderBeforeMount?: 'mobile' | 'desktop';
    breakpoint?: TailwindSizes;
};

function MobileOrDesktopRenderer({
    breakpoint = 'lg',
    ...props
}: MobileOrDesktopRendererProps): React.JSX.Element | null {
    const isMobile = useIsMobile(breakpoint);

    const [mounted, setMounted] = useState(false);

    useLayoutEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional: hydration gate to choose mobile/desktop content only on the client
        setMounted(true);
    }, []);

    if (!props.desktopContent && !props.mobileContent) {
        return null;
    }

    if (!mounted) {
        if (props.renderBeforeMount === 'mobile') {
            return props.mobileContent || null;
        } else if (props.renderBeforeMount === 'desktop') {
            return props.desktopContent || null;
        }
        return null;
    }

    if (isMobile) {
        return props.mobileContent || null;
    } else {
        return props.desktopContent || null;
    }
}

export default MobileOrDesktopRenderer;
